<template>
  <v-app>
    <v-content>
      <PrivacyPolicy/>
    </v-content>
  </v-app>
</template>

<script>
import PrivacyPolicy from './components/PrivacyPolicy'

export default {
  name: 'App',
  components: {
    PrivacyPolicy
  },
  data () {
    return {
      //
    }
  }
}
</script>
